const adaptCreateBrand = (data: Partial<AppBrand>): Partial<IAppBrand> => {
	return {
		name: data.name,
		brand_color: data.brandColor,
		text_color: data.textColor,
	};
};

export default adaptCreateBrand;
